import { useHistory, useParams } from "react-router-dom";
import { useMemo } from "react";
import { buildUrlWithGetParams } from "../utils";
import { UrlParams } from "../types";
import { PUBLIC_TEST_URL } from "../../constants";

export interface NavigateToPageParams {
  testId?: string;
  sessionId?: string;
  module?: string;
  subPage: string;
  subStep?: string;
}

export function useUrlState() {
  const params = useParams<UrlParams>();
  const history = useHistory();
  return useMemo(() => {
    const navigateToParticipationPage = ({
      testId = params.testId,
      sessionId = params.sessionId,
      module = params.module,
      subPage,
      subStep = "",
    }: NavigateToPageParams) => {
      const url = `${PUBLIC_TEST_URL}/${testId}/${sessionId}/${module}/${subPage}/${subStep}`;
      const fullUrl = buildUrlWithGetParams(
        url.replace(/\/+$/, "") //Remove trailing slashes
      );
      history.push(fullUrl);
    };

    const navigateToUrl = (url: string) => {
      history.push(buildUrlWithGetParams(url));
    };

    return {
      ...params,
      navigateToParticipationPage,
      navigateToUrl,
    };
  }, [params, history]);
}
